import { initializeOTel, initializeUnAuthOTel, sendEvent, sendUnAuthEvent, } from '@office-start/otel-telemetry-service';
import { initializeTelemetryService } from './TelemetryService';
export function initializeOTelTelemetryService(appName, appPlatform, browserHost, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, eventCategoryConfig, identity, isCorpNet, oTelEnabled, oTelAriaTenant, telemetryNamespace, sessionId, serverLocation, requestOrigin, userSegment, getCurrentRoute) {
    initializeOTel(appName, appPlatform, browserHost, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, identity, isCorpNet, oTelEnabled, oTelAriaTenant, telemetryNamespace, sessionId, serverLocation, requestOrigin, userSegment);
    initializeTelemetryService([
        {
            // Otel
            logEvent: sendEvent,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            flush: function () { },
        },
    ], getCurrentRoute, eventCategoryConfig);
}
export function initializeUnAuthOTelTelemetryService(appName, appPlatform, browserHost, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, eventCategoryConfig, isCorpNet, oTelEnabled, oTelAriaTenant, telemetryNamespace, sessionId, serverLocation, requestOrigin, userType, getCurrentRoute) {
    initializeUnAuthOTel(appName, appPlatform, browserHost, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, isCorpNet, oTelEnabled, oTelAriaTenant, telemetryNamespace, sessionId, serverLocation, requestOrigin, userType);
    initializeTelemetryService([
        {
            // Otel
            logEvent: sendUnAuthEvent,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            flush: function () { },
        },
    ], getCurrentRoute, eventCategoryConfig);
}
//# sourceMappingURL=initializeOtelTelemetryService.js.map